import React, { useEffect, useState } from 'react';
import axios from 'axios';
import GoogleAnalyticsPanel from './panels/GoogleAnalyticsPanel';
import PlaidIntegrationPanel from './panels/PlaidIntegrationPanel';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

const IntegrationsTab = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [profileLoaded, setProfileLoaded] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setProfileLoaded(true);
      return;
    }
    const load = async () => {
      try {
        const res = await axios.get(`${apiUrl}/user/profile`, {
          headers: { 'x-auth-token': token },
        });
        const role = String(res.data.user?.role || '').toLowerCase();
        setUserRole(res.data.user?.role || '—');
        setIsAdmin(role === 'admin');
      } catch {
        /* ignore */
      } finally {
        setProfileLoaded(true);
      }
    };
    load();
  }, []);

  if (!profileLoaded) {
    return <p className="text-sm text-gray-500">Loading integrations…</p>;
  }

  return (
    <div className="space-y-8">
      <PlaidIntegrationPanel isAdmin={isAdmin} userRole={userRole} />
      <GoogleAnalyticsPanel isAdmin={isAdmin} userRole={userRole} />
    </div>
  );
};

export default IntegrationsTab;
